import React, { useState, useEffect, useRef } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import { Link } from "react-router-dom";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import {
  getPastOrderById,
  getAnswer,
  getEditPastOrder,
  updateReceiveQuantity,
  getAccountingInformation,
  updateAccountingInformation,
} from "../../../service/PastOrder/PastOrderService";
import {
  getAllBusinesslist,
  getAllDepartmentDetailslist,
  listDepartmentByBusinessId,
} from "../../../service/Department/DepartmentService";
import { object } from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { getAllGHGlist } from "../../../service/ghg/ghgService";
import { getALLGLlist } from "../../../service/gl/glService";
import {
  Form,
  Tooltip,
  OverlayTrigger,
  Modal,
  Nav,
  Dropdown,
  Button,
} from "react-bootstrap";
import moment from "moment";
import { getAllIndustryDetailslist } from "../../../service/BusinessUnit/BusinessUnitService";
import SpinnerComponent from "../../components/SpinnerComponent";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import instance from "../../../WebApi/WebApi";
import { getAllCurrencylist } from "../../../service/Currency/CurrencyService";
import countryLocales from "../invoice/Locale";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { FUEL_TYPE, MATERIAL_TYPE, TRANSPORT_TYPE } from "../utils/constant";
import {
  getClassUnspcAdd,
  getFamilyUnspcAdd,
  getSegmentList,
  getSegmentUnspcAdd,
  searchUnspc,
  getSelectedUnspscDetails,
} from "../../../service/Segment/SegmentService";
import {
  addUNSPSCPastOrder,
  getUnspcAdd,
  addUnspscData,
} from "../../../service/Product/ProductService";
import debounce from "lodash/debounce";

const TreeItem = ({ title, children, onClick, isOpen, toggleOpen }) => {
  return (
    <div style={{ marginLeft: "20px" }}>
      <div style={{ display: "flex", margin: "5px" }}>
        <div
          onClick={toggleOpen}
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          {!title.startsWith("Commodity Code") && (
            <span style={{ marginRight: "5px" }}>{isOpen ? "−" : "+"}</span>
          )}
          {title}
        </div>
      </div>

      {isOpen && <div>{children}</div>}
    </div>
  );
};

const Pastorderedit = () => {
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalSearchResult, setTotalSearchResult] = useState(0);
  const [search, setSearch] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchResultsEnd, setSearchResultsEnd] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [selectedSearchResult, setSelectedSearchResult] = useState("");

  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("link-1");
  const [isActive, setActive] = useState("false");
  const [logs, setLogs] = useState(false);
  const [accoutingInfoType, setAccoutingInfoType] = useState("businessUnit");
  const [accountingInformation, setAccountingInformation] = useState([]);
  const params = useParams();
  const [searchParams] = useSearchParams();
  const [ghgData, setGhgData] = useState("");
  const [glData, setGlData] = useState("");
  const [ghgList, setGhgList] = useState([]);
  const [glList, setGlList] = useState([]);
  const [updateProductIds, setUpdateProductIds] = useState("");
  const [productQty, setProductQty] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [hoveredOption, setHoveredOption] = useState(null);
  const [currencyData, setCurrencyData] = useState([]);
  const [manageTransportEmission, setTransportEmission] = useState(0);
  const [emissionData, setEmissionData] = useState([
    { transport_type: "", transport_fuel: "", transport_distance: "" },
  ]);
  const [wasteData, setWasteData] = useState([
    { material_type: "", quantity: "" },
  ]);
  const location = useLocation();
  const pastOrderId = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const [isToggled, setToggled] = useState(false);
  const [getPastOrderId, setPastOrderId] = useState([]);
  const [allData, setAllData] = useState();
  const [businessList, setAllBusinessList] = useState([]);
  const [department, setDepartment] = useState([]);
  const [status, setStatus] = useState("");
  const [businessUnitNameId, setBusinessUnitNameId] = useState("");
  const [departmentId, setDepartmentId] = useState("");
  const [objGhg, setObjGhg] = useState({});
  const [objGl, setObjGl] = useState({});
  const [departmentList, setDepartmentList] = useState([]);
  const [comments, setComments] = useState("");
  const [commentk, setCommentEdit] = useState("");
  const [allLogs, setAllLogs] = useState();
  const [startDate, setStartDate] = useState();
  const [fstartDate, setFStartDate] = useState();
  const [purchaseHistory, setPurchaseHistory] = useState([]);
  const [purchaseHistoriesModal, setPurchaseHistoryModal] = useState(false);
  const [transportEntries, setTransportEntries] = useState([{ id: 1 }]);
  const [wasteEntries, setWasteEntries] = useState([{ id: 1 }]);
  const datePickerRef = useRef(null);
  const timePickerRef = useRef(null);
  const [showUnspc, setShowUnspc] = useState(false);
  const [segmentData, setSegmentData] = useState({});
  const [familyData, setFamilyData] = useState({});
  const [classData, setClassData] = useState({});
  const [commodityData, setCommodityData] = useState({});
  const [selected, setSelected] = useState([]);
  const [selectedAll, setSelectedAll] = useState(false);
  const [searchOptions, setSearchOptions] = useState([]);
  const [getDataSegment, setDataSegment] = useState("");
  const [getDataFamily, setDataFamily] = useState("");
  const [allUnspcFamily, setUnspcFamily] = useState([]);
  const [allUnspcClass, setUnspcClass] = useState([]);
  const [allUnspcComodity, setUnspcComodity] = useState([]);
  const [segmentDataList, setAllSegmentDataList] = useState([]);
  const [itemId, setItemId] = useState();
  const [itemName, setItemName] = useState();

  const [openSegment, setOpenSegment] = useState(null);
  const [openFamily, setOpenFamily] = useState(null);
  const [openClass, setOpenClass] = useState(null);
  const [expandTable, setExpandTable] = useState(false);

  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [selectedProductDetails, setSelectedProductDetails] = useState({});
  const [selectedPastOrderDetails, setSelectedPastOrderDetails] = useState({});
  
  

  const handleSegmentClick = (segment) => {
    setOpenSegment(openSegment === segment ? null : segment);
    if (onDataSegment) onDataSegment(segment);
  };

  const handleFamilyClick = (segment, family) => {
    setOpenFamily(openFamily === family ? null : family);
    setOpenClass(null);
    if (onDataFamily) onDataFamily(family);
  };

  const handleClassClick = (family, classItem) => {
    setOpenClass(openClass === classItem ? null : classItem);
    if (onDataClass) onDataClass(classItem);
  };

  const searchPage = () => {
    navigate("/search-all-unspsc");
  };
  const handleCloseUnspc = () => {
    setSegmentData({});
    setFamilyData({});
    setClassData({});
    setCommodityData({});
    setShowUnspc(false);
    setSelected([]);
    setSelectedAll(false);
    setItemId();
    setItemName();
  };

  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setFocus();
    }
  };
  const handleTimeIconClick = () => {
    if (timePickerRef.current) {
      timePickerRef.current.setFocus();
    }
  };

  const onStatus = (e) => {
    setStatus(e.target.value);
  };

  const onBusinessUnitName = (e) => {
    setDepartmentId("");
    setAccoutingInfoType("businessUnit");
    setBusinessUnitNameId(e.target.value);
    listDepartmentByBusinessId(e.target.value, (res) => {
      setDepartmentList(res.data.departmentList);
    });
  };

  const onComments = (e) => {
    setCommentEdit(e.target.value);
    setComments({ ...comments, commentk: e.target.value });
  };

  const handleToggle = (e, qualityControlId) => {
    const value = e.target.value;

    setAllData((prevState) => ({
      ...prevState,
      [qualityControlId]: {
        answer: value,
        qualityControlId: qualityControlId,
        pastOrderId: pastOrderId.get(`id`),
      },
    }));
  };

  useEffect(() => {
    getallPastOrderList();
    getGHGDataList();
    getGLDataList();
    getAllLogs();
    getCurrencyDataList();
    getSegmentAddList();
  }, []);

  async function getSegmentAddList() {
    getSegmentList().then(function (result) {
      const response = result.data;
      setAllSegmentDataList(response?.data?.segmentList);
    });
  }

  async function getCurrencyDataList() {
    getAllCurrencylist().then(function (result) {
      const response = result?.data;

      const defaultCurrencyData = response?.data?.currencyList.filter(
        (item) => item.defaultCurrency
      );
      setCurrencyData(defaultCurrencyData);
    });
  }

  const getAllLogs = async () => {
    const data = {
      pastOrderId: pastOrderId.get(`id`),
    };
    setIsLoading(true);
    try {
      const response = await instance.post(
        `/customer/past-order/get-past-order-logs`,
        data
      );
      if (response?.data?.success) {
        setAllLogs(response?.data?.data?.pastOrderDetails);
        const commentData =
          response?.data?.data?.pastOrderDetails?.CommentsLogs;
        setComments(commentData[commentData.length - 1]?.comments);
        setIsLoading(false);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
      setIsLoading(false);
    }
  };

  async function getallPastOrderList() {
    setIsLoading(true);
    getPastOrderById(pastOrderId.get(`id`), pastOrderId.get(`invoiceId`)).then(
      function (result) {
        const response = result.data;
        setPastOrderId(response?.data?.pastOrderDetails);
        setEmissionData(
          response?.data?.pastOrderDetails?.transportEmission || [
            { transport_type: "", transport_fuel: "", transport_distance: "" },
          ]
        );
        setWasteData(
          response?.data?.pastOrderDetails?.wastePackageMaterial || [
            { material_type: "", quantity: "" },
          ]
        );
        setGhgData(JSON.stringify(response?.data?.pastOrderDetails?.GHG));
        setGlData(JSON.stringify(response?.data?.pastOrderDetails?.GL));
        setObjGhg(response?.data?.pastOrderDetails?.GHG);
        setObjGl(response?.data?.pastOrderDetails?.GL);
        setStatus(response?.data?.pastOrderDetails?.orderStatus);
        setBusinessUnitNameId(response?.data?.pastOrderDetails?.businessUnitId);
        if (response?.data?.pastOrderDetails?.deliveryDateTime) {
          setStartDate(
            new Date(response?.data?.pastOrderDetails?.deliveryDateTime)
          );
        }

        setDepartmentId(response?.data?.pastOrderDetails?.departmentId);
        listDepartmentByBusinessId(
          response?.data?.pastOrderDetails?.businessUnitId,
          (res) => {
            setDepartmentList(res.data.departmentList);
          }
        );
        setIsLoading(false);
      }
    );
  }

  const onSubmit = () => {
    const QCAnser = [];
    Object.values(allData).map((data) => QCAnser.push(data));

    const data = {
      QCAnser: QCAnser,
    };
    getAnswer(data, (r) => {
      if (r.success === true) {
        toast.success(r.message);
        navigate("/pastorder");
      } else {
        toast.error(r.message);
      }
    });
  };

  async function getGHGDataList() {
    setIsLoading(true);
    getAllGHGlist().then(function (result) {
      const response = result?.data;
      setGhgList(response?.data?.ghgList);
      setIsLoading(false);
    });
  }

  async function getGLDataList() {
    setIsLoading(true);
    getALLGLlist().then(function (result) {
      const response = result?.data;
      setGlList(response?.data?.glList);
      setIsLoading(false);
    });
  }

  const qcSubmit = () => {
    if (allData) {
      const QCAnser = [];
      Object.values(allData).map((data) => QCAnser.push(data));

      const data = {
        QCAnser: QCAnser,
      };
      getAnswer(data, (r) => {
        if (r.success === true) {
          navigate("/pastorder");
        } else {
          toast.error(r.message);
        }
      });
    }
  };

  const onUpdate = () => {
    setIsLoading(true);
    if (allData) {
      qcSubmit();
    }
    getEditPastOrder(
      pastOrderId.get("id"),
      businessUnitNameId === getPastOrderId?.businessUnitId
        ? ""
        : businessUnitNameId,
      commentk,
      getPastOrderId?.invoiceId,
      status === getPastOrderId?.orderStatus ? null : status,
      JSON.parse(ghgData)?.id === getPastOrderId?.GHG?.id ? null : ghgData,
      JSON.parse(glData)?.id === getPastOrderId?.GL?.id ? null : glData,
      departmentId === getPastOrderId?.departmentId ? "" : departmentId,
      fstartDate,
      emissionData,
      wasteData,

      (r) => {
        if (r.success === true) {
          setIsLoading(false);
          toast.success(r.message);
          setBusinessUnitNameId("");
          setCommentEdit("");
          setStatus("");
          setGhgData("");
          setGlData("");
          setDepartmentId("");
          setFStartDate();
          getallPastOrderList();
          getGHGDataList();
          getGLDataList();
          getAllLogs();
          getCurrencyDataList();
        } else {
          setIsLoading(false);
          toast.error(r.message);
        }
      }
    );
  };

  let businessUnitDropdown = <option>Loading...</option>;
  if (businessList && businessList.length > 0) {
    businessUnitDropdown = businessList.map((businessRow, index) => (
      <option
        value={businessRow.id}
        selected={businessRow.id === getPastOrderId.businessUnitId}
      >
        {businessRow.name}
      </option>
    ));
  }

  useEffect(() => {
    getDepartmentList();
  }, []);

  async function getDepartmentList() {
    setIsLoading(true);
    getAllIndustryDetailslist().then((res) => {
      const response = res.data.data;
      setAllBusinessList(response);
      setIsLoading(false);
    });
  }

  const updateProduct = async (e, ItemId) => {
    e.preventDefault();
    setIsLoading(true);
    await updateReceiveQuantity(
      Number(getPastOrderId.invoiceId),
      ItemId,
      productQty,
      searchParams.get("id"),
      (res) => {
        setProductQty("");
        setIsLoading(false);
        toast.success(res.message);
      }
    );
  };

  const _FETCH_ACCOUTING_INFO = async () => {
    setIsLoading(true);
    getAccountingInformation(pastOrderId.get(`id`), (res) => {
      setAccountingInformation(res.data.products);

      setIsLoading(false);
    });
  };

  useEffect(() => {
    _FETCH_ACCOUTING_INFO();
  }, []);

  const [dimension3, setDimension3] = useState(null);
  const [dimension4, setDimension4] = useState(null);

  const _UPDATE_ACCOUNTING_INFO = async (e, unspsc, dimension, type) => {
    e.preventDefault();
    let data = {};
    if (type === "dimension3") {
      data = {
        unspsc: unspsc,
        dimension3: e.target.value,
        dimension4: dimension,
      };
    } else if (type === "dimension4") {
      data = {
        unspsc: unspsc,
        dimension3: dimension,
        dimension4: e.target.value,
      };
    }
    updateAccountingInformation(data, (res) => {});
  };

  const _CHECK_PERMISION = (moduleType) => {
    return JSON.parse(
      localStorage.getItem("gs3_User")
    ).UserJobRole?.AssignRoleModules.some(
      (item) => item.modulename === moduleType
    );
  };

  const _SET_DEPT_ID = (e) => {
    setDepartmentId(e.target.value);
    setAccoutingInfoType("department");
  };

  const onLogs = () => {
    setLogs(true);
  };
  const handleCloseLogs = () => (setLogs(false), setActiveTab("link-1"));
  const handleSelect = async (eventKey) => {
    setIsLoading(true);

    const urlMap = {
      "link-1": "/customer/past-order/get-past-order-logs",
      "link-2": "/customer/past-order/get-past-order-comment-logs",
      "link-3": "/customer/past-order/get-past-order-order-logs",
      "link-4": "/customer/past-order/get-past-order-quantity-logs",
      "link-5": "/customer/past-order/get-past-order-business-logs",
      "link-6": "/customer/past-order/get-past-order-ghg-logs",
      "link-7": "/customer/past-order/get-past-order-delivery-logs",
    };
    const url = urlMap[eventKey];

    if (!url) {
      console.error("Invalid eventKey provided.");
      return;
    }

    const data = {
      pastOrderId: pastOrderId.get(`id`),
    };

    try {
      const response = await instance.post(url, data);
      setAllLogs(response?.data?.data?.pastOrderDetails);

      setActiveTab(eventKey);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error in API call", error);
    }
  };

  const sortedData = ghgList.sort((a, b) => {
    if (a.key < b.key) return -1;
    if (a.key > b.key) return 1;
    return 0;
  });

  const formatCurrency = (amount, currency = "USD") => {
    const selectedLocale = countryLocales.find(
      (item) => item.country === currency
    )?.code;

    return new Intl.NumberFormat(selectedLocale, {
      maximumFractionDigits: 2,
    }).format(amount);
  };
  const handleTransportEmission = (index, e) => {
    const { name, value } = e.target;
    const updatedData = [...emissionData];
    updatedData[index] = {
      ...updatedData[index],
      [name]: value,
    };
    setEmissionData(updatedData);
  };

  const handleAddTransport = () => {
    setEmissionData([
      ...emissionData,
      { transport_type: "", transport_fuel: "", transport_distance: "" },
    ]);
  };

  const handleRemoveTransport = (id) => {
    const updatedData = emissionData.filter((_, i) => i !== id);
    setEmissionData(updatedData);
  };
  const handleAddWaste = () => {
    setWasteData([...wasteData, { material_type: "", quantity: "" }]);
  };
  const handleRemoveWaste = (id) => {
    const updatedData = wasteData.filter((_, i) => i !== id);
    setWasteData(updatedData);
  };

  const handleWasteMaterial = (index, e) => {
    const { name, value } = e.target;
    const updatedData = [...wasteData];
    updatedData[index] = {
      ...updatedData[index],
      [name]: value,
    };
    setWasteData(updatedData);
  };

  const handlePurchaseHistory = async (text) => {
    console.log("text------------------------------");
    console.log(text);
    const data = {
      pastOrderId: pastOrderId.get(`id`),
      productName: text,
    };
    try {
      const response = await instance.post(
        `/customer/past-order/past-order-product-purchase-history`,
        data
      );
      console.log(response?.data?.data?.purchaseHistories);

      setPurchaseHistory(response?.data?.data?.purchaseHistories);
      setPurchaseHistoryModal(true);

      setSelectedPastOrderDetails({
        pastOrderId: pastOrderId.get(`id`),
        invoiceId: pastOrderId.get(`invoiceId`),
        productName: text,
        product: response?.data?.data?.purchaseHistories,
      });

    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
  };

  useEffect(() => {
    console.log("selectedPastOrderDetails");
    console.log(selectedPastOrderDetails);
  }, [selectedPastOrderDetails]);
    

  const onUnspc = (e, id, pname) => {
    e.preventDefault();
    setItemId(id);
    setItemName(pname);
    setShowUnspc(true);
  };

  function convertToArrayOfObjects(array) {
    const result = [];
    for (let index = 0; index < array.length; index++) {
      result.push({
        value: {
          code: array[index].Segment.Segment,
          point: "Segment",
          title: array[index].Segment.SegmentTitle,
          id: array[index].Segment.id,
        },
        label: `${array[index].Segment.SegmentTitle} ( Segment - ${array[index].Segment.Segment})`,
      });
      result.push({
        value: {
          code: array[index].Family.Family,
          point: "Family",
          title: array[index].Family.FamilyTitle,
          id: array[index].Family.id,
        },
        label: `${array[index].Family.FamilyTitle} ( Family - ${array[index].Family.Family})`,
      });
      result.push({
        value: {
          code: array[index].Class.Class,
          point: "Class",
          title: array[index].Class.ClassTitle,
          id: array[index].Class.id,
        },
        label: `${array[index].Class.ClassTitle} ( Class - ${array[index].Class.Class})`,
      });
      result.push({
        value: {
          code: array[index].Commodity.Commodity,
          point: "Commodity",
          title: array[index].Commodity.CommodityTitle,
          id: array[index].Commodity.id,
        },
        label: `${array[index].Commodity.CommodityTitle} ( Commodity - ${array[index].Commodity.Commodity})`,
      });
    }
    let jsonObject = result.map(JSON.stringify);
    let uniqueSet = new Set(result.map(JSON.stringify));
    let uniqueArray = Array.from(uniqueSet).map(JSON.parse);
    setSearchOptions(uniqueArray.filter((item) => item.value !== null));
    setIsLoading(false);
  }

  const _SEARCH_UNSPSC = debounce((data) => {
    setIsLoading(true);
    searchUnspc(data, (res) => {
      convertToArrayOfObjects(res.data);
    });
  }, 1500);

  const _SELECT_UNSPSC = (data) => {
    setIsLoading(true);
    addUNSPSCPastOrder(
      data,
      pastOrderId.get(`invoiceId`),
      itemId,
      itemName,
      pastOrderId.get(`id`),
      (r) => {
        if (r.success === true) {
          toast.success(r.message);
          getallPastOrderList();
          _FETCH_ACCOUTING_INFO();
          setShowUnspc(false);
          setIsLoading(false);
          setSelected([]);
          setSelectedAll(false);
        } else {
          setIsLoading(false);
          toast.error(r.message);
        }
      }
    );
  };

  const onDataSegment = (e) => {
    setIsLoading(true);
    setDataSegment(e);
    getSegmentUnspcAdd(e, (r) => {
      if (r.success === true) {
        setUnspcFamily(r?.data?.listUnspsc);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        toast.error(r.message);
      }
    });
  };

  const onDataFamily = (e) => {
    setIsLoading(true);
    setDataFamily(e);

    getFamilyUnspcAdd(getDataSegment, e, (r) => {
      if (r.success === true) {
        setUnspcClass(r?.data?.listUnspsc);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        toast.error(r.message);
      }
    });
  };

  const onDataClass = (e) => {
    setIsLoading(true);
    setDataFamily(e);

    getClassUnspcAdd(getDataSegment, getDataFamily, e, (r) => {
      if (r.success === true) {
        setUnspcComodity(r?.data?.listUnspsc);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        toast.error(r.message);
      }
    });
  };

  const searchUnspsc = debounce((input) => {
    setSearch("");
    setPage(1);
    setTotalSearchResult(0);
    setSearchResults([]);

    if (!input) {
      return;
    }

    setSearch(input);
  }, 1500);

  const loadMoreResults = () => {
    setPage(page + 1);
  };

  function getSearchResults() {
    setIsSearchLoading(true);

    searchUnspc(search, page, "user", (res) => {
      if (!res.data || res.data.results.length === 0) {
        setSearchResults([]);
        setIsSearchLoading(false);
        return;
      }

      setSearchResults((prevResults) => [...prevResults, ...res.data.results]);
      setTotalSearchResult(res.data.total);
      setSearchResultsEnd(res.data.reachedEnd);
      setIsSearchLoading(false);
    });
  }

  function getUnspscData(result) {
    toast.dismiss();

    toast.warning(
      <div className="toast-content">
        <div className="toast-message">
          Are you sure you want to add this UNSPSC?
        </div>
        <div className="button-container">
          <button
            className="yes-button"
            onClick={() => {
              getSelectedUnspscDetails(result, (res) => {
                if (res.success) {
                  const data = {
                    value: {
                      id: res.data.details.id,
                      title: res.data.details.title,
                      code: res.data.details.code,
                      point: res.data.details.point,
                    },
                  };

                  addUNSPSCPastOrder(
                    data,
                    pastOrderId.get(`invoiceId`),
                    itemId,
                    itemName,
                    pastOrderId.get(`id`),
                    (r) => {
                      if (r.success === true) {
                        toast.success(r.message);
                        setPage(1);
                        setSearchResults([]);
                        setSearch("");
                        getallPastOrderList();
                        setSelected([]);
                        handleCloseUnspc();
                      } else {
                        toast.error(r.message);
                      }
                    }
                  );
                }
              });
            }}
          >
            Yes
          </button>
          <button
            className="no-button ms-2"
            onClick={() => {
              toast.dismiss();
            }}
          >
            No
          </button>
        </div>
      </div>,
      {
        autoClose: true,
        closeOnClick: true,
      }
    );
  }

  useEffect(() => {
    getSearchResults();
  }, [search]);

  useEffect(() => {
    if (page > 1) {
      getSearchResults();
    }
  }, [page]);






  
    const getPurchaseHistoryByProductId = async (product_id) => {
      const response = await instance.get(
        `/customer/product/get-product-details-by-id?productId=${product_id}`
      );
  
      if (response?.data?.status != 200) {
        toast.error("Purchase History not found!");
        // console.log("response", response);
      } else {
        // toast.error("Purchase History found!");
        // console.log("response", response?.data?.data);
        // console.log("response", response?.data?.data?.getProductDetails);
        setPurchaseHistory(response?.data?.data?.purchaseHistories);
        setSelectedPastOrderDetails(response?.data?.data?.pastOrder);
        setSelectedProductDetails(response?.data?.data?.productDetails);
        setSelectedInvoiceId(response?.data?.data?.invoice_id);
        setShowPurchaseModal(true);
      }
    };

    const currencyFormatter = require("currency-formatter");

  

  return (
    <>
      <div className="container-fluid">
        <div className="dbMain  pastorder">
          <Leftpanel />
          <div className="dbRight">
            <Header
              link="/pastorder"
              breadcm=""
              title={t("order")}
              description=""
            />
            <div className="commonBase mb-3">
              <div className="row orderDetl">
                <div className="col-md-6">
                  <h5>
                    {
                      getPastOrderId?.Invoice?.invoice?.Invoice
                        ?.AccountingCustomerParty?.Party?.PartyName?.Name?._text
                    }
                  </h5>
                  <h5>
                    {!getPastOrderId?.Department
                      ? ""
                      : getPastOrderId?.Department?.BusinessUnit?.name}
                  </h5>
                  <h5>
                    {!getPastOrderId?.Department
                      ? ""
                      : `${getPastOrderId?.Department.name}`}
                  </h5>
                  <p>
                    <div>
                      {!getPastOrderId?.Department
                        ? getPastOrderId?.Invoice?.invoice?.Invoice
                            ?.AccountingCustomerParty?.Party?.PostalAddress
                            ?.StreetName?._text
                        : getPastOrderId?.Department?.BusinessUnit?.address}
                    </div>
                    <div className="d-flex">
                      <div>
                        {!getPastOrderId?.Department
                          ? ""
                          : `${getPastOrderId?.Department?.BusinessUnit?.zipcode}, `}
                      </div>
                      <div className="ms-1">
                        {!getPastOrderId?.Department
                          ? getPastOrderId?.Invoice?.invoice?.Invoice
                              ?.AccountingCustomerParty?.Party?.PostalAddress
                              ?.CityName?._text
                          : getPastOrderId?.Department?.BusinessUnit?.city}
                      </div>
                      <div>
                        {!getPastOrderId?.Department
                          ? ""
                          : `, ${getPastOrderId?.Department?.BusinessUnit?.state}, `}
                      </div>
                      <div className="ms-1">
                        {!getPastOrderId?.Department
                          ? getPastOrderId?.Invoice?.invoice?.Invoice
                              ?.AccountingCustomerParty?.Party?.PostalAddress
                              ?.Country?.IdentificationCode?._text
                          : getPastOrderId?.Department?.BusinessUnit?.country}
                      </div>
                    </div>
                  </p>
                  <p>{t("telephone")}: </p>
                  <p>{t("website")} </p>
                  <h6>
                    {t("business_units")}: -{" "}
                    <i className="fa-solid fa-circle-check"></i>
                    <select
                      name=""
                      id=""
                      onChange={onBusinessUnitName}
                      className="poEdit"
                      style={{ maxWidth: "inherit" }}
                    >
                      <option value="">{t("select_operating_units")}</option>
                      {businessUnitDropdown}
                    </select>
                  </h6>
                  <h6>
                    {t("department")}: -{" "}
                    <i className="fa-solid fa-circle-check"></i>
                    <select
                      name=""
                      id=""
                      onChange={_SET_DEPT_ID}
                      className="poEdit"
                      style={{ maxWidth: "inherit" }}
                    >
                      <option value="">{t("select_departments")}</option>
                      {departmentList.length > 0 &&
                        departmentList.map((item, index) => {
                          return (
                            <option
                              value={item.id}
                              key={item.id}
                              selected={item.id === departmentId}
                            >
                              {item.name}
                            </option>
                          );
                        })}
                    </select>
                  </h6>
                </div>
                {isLoading && <SpinnerComponent isLoading={isLoading} />}

                <div className="col-md-6">
                  <h5>{t("order")}</h5>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      position: "relative",
                    }}
                  >
                    <h6 style={{ marginRight: "10px" }}>Delivery Date:</h6>
                    <DatePicker
                      ref={datePickerRef}
                      selected={startDate}
                      onChange={(date) => (
                        setStartDate(date), setFStartDate(date)
                      )}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="Select a date"
                      className="supplierEditInput"
                      style={{ marginRight: "10px" }}
                    />
                    <i
                      className="fa fa-calendar-alt calendar-icon"
                      onClick={handleIconClick}
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        left: "235px",
                      }}
                    ></i>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      position: "relative",
                    }}
                  >
                    <h6>Delivery Time: </h6>
                    <DatePicker
                      ref={timePickerRef}
                      selected={startDate}
                      onChange={(date) => (
                        setStartDate(date), setFStartDate(date)
                      )}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      placeholderText="Select a time"
                      className="supplierEditInput ms-1"
                    />
                    <i
                      className="fa fa-clock calendar-icon"
                      onClick={handleTimeIconClick}
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        left: "235px",
                      }}
                    ></i>
                  </div>

                  <h6>Order ID: {getPastOrderId?.id}</h6>
                  <h6>
                    Invoice ID:{" "}
                    <Link
                      to={`/invoicedetails?id=${getPastOrderId?.orginalInvoiceId}`}
                    >
                      {getPastOrderId?.Invoice?.invoice?.Invoice?.ID?._text}
                    </Link>
                  </h6>
                  <h6>
                    Order Status: <i className="fa-solid fa-circle-check"></i>
                    <select
                      name=""
                      id=""
                      onChange={onStatus}
                      className="poEdit"
                      style={{ maxWidth: "inherit" }}
                    >
                      <option value="">{t("selectStatus")}</option>
                      {_CHECK_PERMISION("Orders") &&
                        !(
                          _CHECK_PERMISION("PastOrder Approved with Issues") ||
                          _CHECK_PERMISION("PastOrder Approved") ||
                          _CHECK_PERMISION("PastOrder Received with Issues") ||
                          _CHECK_PERMISION("PastOrder Received")
                        ) && (
                          <>
                            <option
                              value="Created"
                              selected={status === "Created"}
                            >
                              {t("created")}
                            </option>
                          </>
                        )}
                      {_CHECK_PERMISION("Orders") &&
                        !(
                          _CHECK_PERMISION("PastOrder Approved with Issues") ||
                          _CHECK_PERMISION("PastOrder Approved")
                        ) && (
                          <>
                            <option
                              value="Received,comments"
                              selected={status === "Received,comments"}
                            >
                              {t("receivedWithIssues")}
                            </option>
                            <option
                              value="Received"
                              selected={status === "Received"}
                            >
                              {t("received")}
                            </option>
                          </>
                        )}
                      {_CHECK_PERMISION("Orders") &&
                        !(
                          _CHECK_PERMISION("PastOrder Received with Issues") ||
                          _CHECK_PERMISION("PastOrder Received")
                        ) && (
                          <>
                            <option
                              value="Approved,comments"
                              selected={status === "Approved,comments"}
                            >
                              {t("approvedWithComments")}
                            </option>
                            <option
                              value="Approved"
                              selected={status === "Approved"}
                            >
                              {t("approved")}
                            </option>
                          </>
                        )}
                      {_CHECK_PERMISION("Orders") &&
                        !(
                          _CHECK_PERMISION("PastOrder Approved with Issues") ||
                          _CHECK_PERMISION("PastOrder Approved") ||
                          _CHECK_PERMISION("PastOrder Received with Issues") ||
                          _CHECK_PERMISION("PastOrder Received")
                        ) && (
                          <>
                            <option
                              value="Rejected"
                              selected={status === "Rejected"}
                            >
                              {t("rejected")}
                            </option>
                          </>
                        )}

                      {_CHECK_PERMISION("PastOrder Approved with Issues") &&
                        _CHECK_PERMISION("PastOrder Approved") &&
                        _CHECK_PERMISION("PastOrder Received with Issues") &&
                        _CHECK_PERMISION("PastOrder Received") &&
                        _CHECK_PERMISION("Orders") &&
                        _CHECK_PERMISION("Configuration") &&
                        _CHECK_PERMISION("Invoices") &&
                        _CHECK_PERMISION("Products") &&
                        _CHECK_PERMISION("Suppliers") &&
                        _CHECK_PERMISION("Reports") &&
                        _CHECK_PERMISION("Business Unit") &&
                        _CHECK_PERMISION("Department") &&
                        _CHECK_PERMISION("Users") && (
                          <>
                            <option
                              value="Created"
                              selected={status === "Created"}
                            >
                              {t("created")}
                            </option>
                            <option
                              value="Received,comments"
                              selected={status === "Received,comments"}
                            >
                              {t("receivedWithIssues")}
                            </option>
                            <option
                              value="Received"
                              selected={status === "Received"}
                            >
                              {t("received")}
                            </option>
                            <option
                              value="Approved,comments"
                              selected={status === "Approved,comments"}
                            >
                              {t("approvedWithIssues")}
                            </option>
                            <option
                              value="Approved"
                              selected={status === "Approved"}
                            >
                              {t("approved")}
                            </option>
                            <option
                              value="Rejected"
                              selected={status === "Rejected"}
                            >
                              {t("rejected")}
                            </option>
                          </>
                        )}
                    </select>
                  </h6>
                </div>
              </div>
              <div className="row ordervendor">
                <div className="col-md-6">
                  <h6>Vendor</h6>
                  <div className="pd">
                    <span className="pdn">Company Name :</span>{" "}
                    <span>
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingSupplierParty?.Party?.PartyName?.Name
                          ?._text
                      }
                    </span>
                  </div>
                  <div className="pd">
                    <span className="pdn">Contact or Department :</span>{" "}
                    <span>
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingSupplierParty?.Party?.Contact?.Name?._text
                      }
                    </span>
                  </div>
                  <div className="pd">
                    <span className="pdn">Address Line 1 :</span>{" "}
                    <span>
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingSupplierParty?.Party?.PostalAddress
                          ?.StreetName?._text
                      }
                    </span>
                  </div>
                  <div className="pd">
                    <span className="pdn">Address Line 2 :</span>
                    <span>
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingSupplierParty?.Party?.PostalAddress
                          ?.CityName?._text
                      }
                    </span>
                    <span>
                      {`, ` +
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingSupplierParty?.Party?.PostalAddress
                          ?.Country?.IdentificationCode?._text}
                    </span>
                  </div>
                  <div className="pd">
                    <span className="pdn">Phone :</span>{" "}
                    <span>
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingSupplierParty?.Party?.Contact?.Telephone
                          ?._text
                      }
                    </span>
                  </div>
                  <div className="pd">
                    <span className="pdn">Fax :</span>{" "}
                    <span>
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingSupplierParty?.Party?.Contact
                          ?.ElectronicMail?._text
                      }
                    </span>
                  </div>
                </div>
                <div className="col-md-6">
                  <h6>Ship to</h6>
                  <div className="pd">
                    <span className="pdn">Name :</span>{" "}
                    <span>
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingCustomerParty?.Party?.PartyName?.Name
                          ?._text
                      }
                    </span>
                  </div>
                  <div className="pd">
                    <span className="pdn">Company Name :</span>{" "}
                    <span>
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingCustomerParty?.Party?.PartyLegalEntity
                          ?.RegistrationName?._text
                      }
                    </span>
                  </div>
                  <div className="pd">
                    <span className="pdn">Address Line 1 :</span>{" "}
                    <span>
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingCustomerParty?.Party?.PostalAddress
                          ?.StreetName?._text
                      }
                    </span>
                  </div>
                  <div className="pd">
                    <span className="pdn">Address Line 2 :</span>{" "}
                    <span>
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingCustomerParty?.Party?.PostalAddress
                          ?.CityName?._text
                      }
                      {/* {", "} */}
                      {
                        getPastOrderId?.Invoice?.invoice?.Invoice
                          ?.AccountingCustomerParty?.Party?.PostalAddress
                          ?.Country?.IdentificationCode?._text
                      }
                    </span>
                  </div>
                  <div className="pd">
                    <span className="pdn">Phone :</span>
                  </div>
                  <div className="pd">
                    <span className="pdn">Email :</span>
                  </div>
                </div>
              </div>

              <div className="poTable respTable">
                <table>
                  <thead>
                    <tr>
                      <th>ITEM #</th>
                      <th>DESCRIPTION</th>
                      <th>QTY</th>
                      <th>QTY REC</th>
                      <th>UNIT PRICE</th>
                      <th>DISCOUNT</th>
                      <th>KgCO2</th>
                      <th>UNSPSC</th>
                      <th>TOTAL</th>
                      <th>Logs</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!Array.isArray(
                      getPastOrderId?.Invoice?.invoice?.Invoice?.InvoiceLine
                    ) &&
                      [
                        getPastOrderId?.Invoice?.invoice?.Invoice?.InvoiceLine,
                      ]?.map((d) => (
                        <tr>
                          <td data-label="Item #">
                            {d?.Item?.SellersItemIdentification?.ID?._text}
                          </td>
                          <td data-label="Description">
                            {d?.Item?.Name?._text}
                          </td>
                          <td data-label="Qty">{d?.InvoicedQuantity?._text}</td>
                          <td data-label="Quantity Received">
                            <div className="qtyInp">
                              <input
                                type="text"
                                defaultValue={
                                  d?.ReceivedQuantity?._text
                                    ? d?.ReceivedQuantity?._text
                                    : d?.InvoicedQuantity?._text
                                }
                                onChange={(e) => setProductQty(e.target.value)}
                              />
                              &nbsp;
                              <i
                                className="fa-regular fa-floppy-disk floppy"
                                onClick={(e) => updateProduct(e, d?.ID?._text)}
                              ></i>
                            </div>
                          </td>
                          <td data-label="Unit Price">
                            {currencyData[0]?.name} &nbsp;
                            {formatCurrency(
                              Number(d?.Price?.PriceAmount?._text),
                              currencyData[0]?.name
                            )}
                          </td>
                          <td data-label="Discount">----</td>
                          <td data-label="CARBON FOOTPRINT">{`${
                            d?.co2Print?._text ? d?.co2Print?._text : "----"
                          }`}</td>
                          <td data-label="Total">
                            {currencyData[0]?.name} &nbsp;
                            {formatCurrency(
                              Number(d?.LineExtensionAmount?._text),
                              currencyData[0]?.name
                            )}
                          </td>
                          <td data-label="logs">Logs</td>
                        </tr>
                      ))}
                    {Array.isArray(
                      getPastOrderId?.Products
                      // getPastOrderId?.Invoice?.invoice?.Invoice?.InvoiceLine
                    ) &&
                      getPastOrderId?.Products?.map(
                      // getPastOrderId?.Invoice?.invoice?.Invoice?.InvoiceLine?.map(
                        (d) => (
                          <tr>
                            <td data-label="Item #">
                              {d?.item?.Item?.SellersItemIdentification?.ID?._text}
                            </td>
                            <td data-label="Description">
                              {d?.item?.Item?.Name?._text}
                            </td>
                            <td data-label="Qty">
                              {d?.item?.InvoicedQuantity?._text}
                            </td>
                            <td data-label="Quantity Received">
                              <div className="qtyInp">
                                <input
                                  type="text"
                                  defaultValue={
                                    d?.item?.ReceivedQuantity?._text
                                      ? d?.item?.ReceivedQuantity?._text
                                      : d?.item?.InvoicedQuantity?._text
                                  }
                                  onChange={(e) =>
                                    setProductQty(e.target.value)
                                  }
                                />
                                &nbsp;
                                <i
                                  className="fa-regular fa-floppy-disk floppy"
                                  onClick={(e) =>
                                    updateProduct(e, d?.item?.ID?._text)
                                  }
                                ></i>
                              </div>
                            </td>
                            <td data-label="Unit Price">
                              {currencyData[0]?.name} &nbsp;
                              {formatCurrency(
                                Number(d?.item?.Price?.PriceAmount?._text),
                                currencyData[0]?.name
                              )}
                            </td>

                            <td data-label="Discount">----</td>

                            {/* CO2 column is not sure, need to modify */}
                            <td data-label="CARBON FOOTPRINT">{`${
                              d?.item?.co2Print?._text ? d?.item?.co2Print?._text : "----"
                            }`}</td>
                            {/* This column is not sure, need to modify */}
                            <td
                              data-label="UNSPSC"
                              style={{ textAlign: "center" }}
                            >
                              {d?.unspscTitle ? (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip
                                      id="tooltip"
                                      style={{ fontSize: "10px" }}
                                    >
                                      {d?.unspscTitle}
                                    </Tooltip>
                                  }
                                >
                                  <Button variant="success" className="unspsc">
                                    {`${d?.unspscTitle?.slice(0, 10)}${
                                      d?.unspscTitle?.length > 10
                                        ? "..."
                                        : ""
                                    }`}
                                  </Button>
                                </OverlayTrigger>
                              ) : (
                                <Link
                                  to={"javascript:void(0)"}
                                  onClick={(e) =>
                                    onUnspc(
                                      e,
                                      d?.item?.ID?._text,
                                      d?.item?.Item?.Name?._text
                                    )
                                  }
                                >
                                  <i className="fa-regular fa-circle-plus"></i>
                                </Link>
                              )}
                            </td>
                            <td data-label="Total">
                              {currencyData[0]?.name} &nbsp;
                              {formatCurrency(
                                Number(d?.item?.LineExtensionAmount?._text),
                                currencyData[0]?.name
                              )}
                            </td>
                            <td data-label="Total">
                              <i
                                className="fa fa-history"
                                style={{ cursor: "pointer" }}
                                aria-hidden="true"
                                onClick={() =>
                                  getPurchaseHistoryByProductId(d?.id)
                                }
                              ></i>
                            </td>

                            {/* OLD Column */}
                            {/* <td data-label="Total">
                              <i
                                className="fa fa-history"
                                style={{ cursor: "pointer" }}
                                aria-hidden="true"
                                onClick={() =>
                                  handlePurchaseHistory(d?.Item?.Name?._text)
                                }
                              ></i>
                            </td> */}
                          </tr>
                        )
                      )}
                  </tbody>
                </table>
              </div>

              <div className="row">
                <div className="col-md-4 order-md-1">
                  <div className="subtotal">
                    <h6>Subtotal: </h6>{" "}
                    <span>
                      {currencyData[0]?.name} &nbsp;
                      {formatCurrency(
                        Number(
                          getPastOrderId?.Invoice?.invoice?.Invoice
                            ?.LegalMonetaryTotal?.LineExtensionAmount?._text || 0
                        ),
                        currencyData[0]?.name
                      )}
                    </span>
                  </div>
                  <div className="subtotal">
                    <h6>
                      Tax:{" "}
                      {Number(
                        getPastOrderId?.Invoice?.invoice?.Invoice?.TaxTotal
                          ?.TaxSubtotal?.TaxCategory?.Percent?._text || 0
                      )}
                      %{" "}
                    </h6>{" "}
                    <span className="boxborder">
                      {currencyData[0]?.name} &nbsp;
                      {formatCurrency(
                        Number(
                          (Number(
                            getPastOrderId?.Invoice?.invoice?.Invoice
                              ?.LegalMonetaryTotal?.LineExtensionAmount?._text || 0
                          ) *
                            Number(
                              getPastOrderId?.Invoice?.invoice?.Invoice
                                ?.TaxTotal?.TaxSubtotal?.TaxCategory?.Percent
                                ?._text || 0
                            )) /
                            100
                        ),
                        currencyData[0]?.name
                      )}
                    </span>
                  </div>
                  <div className="subtotal">
                    <h6>Shipping: </h6> <span className="boxborder">---</span>
                  </div>
                  <div className="subtotal">
                    <h6>Other: </h6> <span className="boxborder">---</span>
                  </div>
                  <div className="subtotal">
                    <h6>
                      <strong>Total:</strong>{" "}
                    </h6>{" "}
                    <span className="boxborder totl">
                      {currencyData[0]?.name} &nbsp;
                      {formatCurrency(
                        Number(
                          (Number(
                            getPastOrderId?.Invoice?.invoice?.Invoice
                              ?.LegalMonetaryTotal?.LineExtensionAmount?._text || 0
                          ) *
                            Number(
                              getPastOrderId?.Invoice?.invoice?.Invoice
                                ?.TaxTotal?.TaxSubtotal?.TaxCategory?.Percent
                                ?._text || 0
                            )) /
                            100 +
                            Number(
                              getPastOrderId?.Invoice?.invoice?.Invoice
                                ?.LegalMonetaryTotal?.LineExtensionAmount?._text || 0
                            )
                        ),
                        currencyData[0]?.name
                      )}
                    </span>
                  </div>
                </div>
                <div className="col-md-8">
                  <table className="instruction">
                    <tr>
                      <th>Comments or Special Instructions</th>
                    </tr>
                    <tr>
                      <td>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="Comments & special instructions"
                          className="comnt"
                          name="comments"
                          defaultValue={comments}
                          onChange={(e) => setCommentEdit(e.target.value)}
                        />
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div className="commonBase mb-4">
              <h6 className="mb-3">Add GHG Key</h6>
              <div className="additembox groupBordr">
                <Dropdown>
                  <Dropdown.Toggle
                    variant="success"
                    id="dropdown-basic"
                    style={{ height: "100%" }}
                  >
                    {ghgData ? JSON.parse(ghgData)?.key : "Select GHG Key"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    style={{
                      maxHeight: "250px",
                      overflowY: "auto",
                    }}
                  >
                    {sortedData?.map((con) => (
                      <OverlayTrigger
                        key={con.id}
                        placement="top"
                        overlay={
                          <Tooltip
                            id={`tooltip-${con.id}`}
                            style={{ fontSize: "18px" }}
                          >
                            {con?.value}
                          </Tooltip>
                        }
                      >
                        <Dropdown.Item
                          as="button"
                          style={{ height: "100%" }}
                          onClick={() => setGhgData(JSON.stringify(con))}
                        >
                          {`(${con.key})`}
                        </Dropdown.Item>
                      </OverlayTrigger>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Add GHG Key"
                  value={ghgData ? JSON.parse(ghgData)?.value : ""}
                  disabled
                />
              </div>
            </div>
            <div className="commonBase mb-4">
              <div className="col-md-12">
                <h5 className="mb-3">Transport Emission</h5>
                {emissionData.map((entry, index) => (
                  <div className="row align-items-center" key={index}>
                    <div className="col-md-4 d-flex align-items-center">
                      <label className="m-2" style={{ fontWeight: "bold" }}>
                        Transport Type:
                      </label>
                      <select
                        className="poEdit"
                        name="transport_type"
                        value={entry?.transport_type}
                        style={{ maxWidth: "200px", width: "100%" }}
                        onChange={(e) => handleTransportEmission(index, e)}
                        id="transport_type"
                      >
                        <option value="">Select Transport Type</option>
                        {TRANSPORT_TYPE.map((fuelType, idx) => (
                          <option
                            value={fuelType}
                            key={idx}
                            selected={fuelType === entry?.transport_type}
                          >
                            {t(fuelType)}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-4 d-flex align-items-center">
                      <label className="m-2" style={{ fontWeight: "bold" }}>
                        Fuel Type:
                      </label>
                      <select
                        className="poEdit"
                        name="transport_fuel"
                        value={entry?.transport_fuel}
                        style={{ maxWidth: "200px", width: "100%" }}
                        id="transport_fuel"
                        onChange={(e) => handleTransportEmission(index, e)}
                      >
                        <option value="">Select Fuel Type</option>
                        {FUEL_TYPE.map((fuelType, idx) => (
                          <option
                            value={fuelType}
                            key={idx}
                            selected={fuelType === entry?.transport_fuel}
                          >
                            {t(fuelType)}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-4 d-flex align-items-center">
                      <div className="d-flex align-items-center">
                        <label
                          htmlFor={`transport-distance-${index}`}
                          className="m-2 form-label"
                          style={{ fontWeight: "bold" }}
                        >
                          Distance
                        </label>
                        <input
                          type="text"
                          name="transport_distance"
                          id={`transport-distance`}
                          value={entry?.transport_distance}
                          onChange={(e) => handleTransportEmission(index, e)}
                          className="border-0 border-bottom"
                          style={{
                            outline: "none",
                            boxShadow: "none",
                            width: "150px",
                            marginRight: "5px",
                          }}
                        />
                        <span className="m-2">Km</span>
                      </div>

                      {index > 0 && (
                        <i
                          className="fa fa-circle-minus"
                          style={{ cursor: "pointer", marginRight: "10px" }}
                          onClick={() => handleRemoveTransport(index)}
                        ></i>
                      )}
                      <i
                        className="fa fa-circle-plus"
                        style={{ cursor: "pointer" }}
                        onClick={handleAddTransport}
                      ></i>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="commonBase mb-4">
              <div className="col-md-12">
                <h5 className="mb-3">Waste Packaging Material </h5>
                {wasteData.map((entry, index) => (
                  <div className="row align-items-center" key={index}>
                    <div className="col-md-4 d-flex align-items-center">
                      <label className="m-2" style={{ fontWeight: "bold" }}>
                        Material Type:
                      </label>
                      <select
                        className="poEdit"
                        style={{ maxWidth: "200px", width: "100%" }}
                        name="material_type"
                        value={entry?.material_type}
                        id="material_type"
                        onChange={(e) => handleWasteMaterial(index, e)}
                      >
                        <option value="">Select Material Type</option>
                        {MATERIAL_TYPE.map((materialType, index) => (
                          <option
                            value={materialType}
                            key={index}
                            selected={materialType === entry?.material_type}
                          >
                            {t(materialType)}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-4 d-flex align-items-center">
                      <div className="d-flex align-items-center">
                        <label
                          htmlFor={`transport-distance`}
                          className="m-2 form-label"
                          style={{ fontWeight: "bold" }}
                        >
                          Quantity
                        </label>
                        <input
                          type="number"
                          id={`waste-quantity`}
                          className="border-0 border-bottom"
                          style={{
                            outline: "none",
                            boxShadow: "none",
                            width: "150px",
                            marginRight: "5px",
                          }}
                          name="quantity"
                          value={entry?.quantity}
                          onChange={(e) => handleWasteMaterial(index, e)}
                        />
                        <span className="m-2">Kg</span>
                      </div>
                    </div>
                    <div className="col-md-4 d-flex align-items-center">
                      <div className="d-flex align-items-center">
                        {index > 0 && (
                          <i
                            className="fa fa-circle-minus"
                            style={{ cursor: "pointer", marginRight: "10px" }}
                            onClick={() => handleRemoveWaste(index)}
                          ></i>
                        )}
                        <i
                          className="fa fa-circle-plus"
                          style={{ cursor: "pointer" }}
                          onClick={handleAddWaste}
                        ></i>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="commonBase mb-3">
              <h5>{t("quality_questions")}</h5>
              {getPastOrderId?.SelectedPastOrderQualityControls?.map((d, i) => (
                <div className="qualityBase" key={i}>
                  <p>{d?.QualityControl?.text}</p>
                  <div className="radioline invBasis">
                    <>
                      <div className="invLft" style={{ marginRight: "5px" }}>
                        <input
                          type="radio"
                          id={`test1_${d?.QualityControl?.id}`}
                          value="Yes"
                          checked={
                            allData
                              ? allData[d?.QualityControl?.id]?.answer === "Yes"
                              : d?.answer === "Yes"
                          }
                          name={`name${d?.QualityControl?.id}`}
                          onChange={(e) =>
                            handleToggle(e, d?.QualityControl?.id)
                          }
                        />
                        <label htmlFor={`test1_${d?.QualityControl?.id}`}>
                          Yes
                        </label>
                      </div>
                      <div className="invrgt">
                        <input
                          type="radio"
                          id={`test2_${d?.QualityControl?.id}`}
                          value="No"
                          checked={
                            allData
                              ? allData[d?.QualityControl?.id]?.answer === "No"
                              : d?.answer === "No"
                          }
                          name={`name${d?.QualityControl?.id}`}
                          onChange={(e) =>
                            handleToggle(e, d?.QualityControl?.id)
                          }
                        />
                        <label htmlFor={`test2_${d?.QualityControl?.id}`}>
                          No
                        </label>
                      </div>
                    </>
                  </div>
                </div>
              ))}
            </div>
            <div className="commonBase mb-4">
              <div className="col-md-12">
                <h5 className="mb-3">Order Log</h5>
                <Link to="javascript:void(0)" onClick={onLogs}>
                  <i className="fa fa-history" aria-hidden="true"></i>
                </Link>
              </div>
            </div>
            <div className="commonBase mb-4">
              <h5 className="mb-3">Order Status</h5>

              {["radio"].map((type) => (
                <div key={`OrderStatus`} className="additembox adnewbox">
                  {_CHECK_PERMISION("Orders") &&
                    !(
                      _CHECK_PERMISION("PastOrder Approved with Issues") ||
                      _CHECK_PERMISION("PastOrder Approved") ||
                      _CHECK_PERMISION("PastOrder Received with Issues") ||
                      _CHECK_PERMISION("PastOrder Received")
                    ) && (
                      <>
                        <Form.Check
                          reverse
                          label="Created"
                          name="OrderStatus"
                          type={type}
                          id={`Created`}
                          checked={status === "Created"}
                          onChange={onStatus}
                          value={"Created"}
                        />
                      </>
                    )}
                  {_CHECK_PERMISION("Orders") &&
                    !(
                      _CHECK_PERMISION("PastOrder Approved with Issues") ||
                      _CHECK_PERMISION("PastOrder Approved")
                    ) && (
                      <>
                        <Form.Check
                          reverse
                          label="Received with comments"
                          name="OrderStatus"
                          type={type}
                          id={`ReceivedWithIssues`}
                          checked={status === "Received,comments"}
                          onChange={onStatus}
                          value={"Received,comments"}
                        />
                        <Form.Check
                          reverse
                          label="Received"
                          name="OrderStatus"
                          type={type}
                          id={`Received`}
                          checked={status === "Received"}
                          onChange={onStatus}
                          value={"Received"}
                        />
                      </>
                    )}
                  {_CHECK_PERMISION("Orders") &&
                    !(
                      _CHECK_PERMISION("PastOrder Received with Issues") ||
                      _CHECK_PERMISION("PastOrder Received")
                    ) && (
                      <>
                        <Form.Check
                          reverse
                          label="Approved with comments"
                          name="OrderStatus"
                          type={type}
                          id={`ApprovedWithIssues`}
                          checked={status === "Approved,comments"}
                          onChange={onStatus}
                          value={"Approved,comments"}
                        />
                        <Form.Check
                          reverse
                          label="Approved"
                          name="OrderStatus"
                          type={type}
                          id={`Approved`}
                          checked={status === "Approved"}
                          onChange={onStatus}
                          value={"Approved"}
                        />
                      </>
                    )}
                  {_CHECK_PERMISION("Orders") &&
                    !(
                      _CHECK_PERMISION("PastOrder Approved with Issues") ||
                      _CHECK_PERMISION("PastOrder Approved") ||
                      _CHECK_PERMISION("PastOrder Received with Issues") ||
                      _CHECK_PERMISION("PastOrder Received")
                    ) && (
                      <>
                        <Form.Check
                          reverse
                          label="Rejected"
                          name="OrderStatus"
                          type={type}
                          id={`Rejected`}
                          checked={status === "Rejected"}
                          onChange={onStatus}
                          value={"Rejected"}
                        />
                      </>
                    )}
                  {_CHECK_PERMISION("PastOrder Approved with Issues") &&
                    _CHECK_PERMISION("PastOrder Approved") &&
                    _CHECK_PERMISION("PastOrder Received with Issues") &&
                    _CHECK_PERMISION("PastOrder Received") &&
                    _CHECK_PERMISION("Orders") &&
                    _CHECK_PERMISION("Configuration") &&
                    _CHECK_PERMISION("Invoices") &&
                    _CHECK_PERMISION("Products") &&
                    _CHECK_PERMISION("Suppliers") &&
                    _CHECK_PERMISION("Reports") &&
                    _CHECK_PERMISION("Business Unit") &&
                    _CHECK_PERMISION("Department") &&
                    _CHECK_PERMISION("Users") && (
                      <>
                        <Form.Check
                          reverse
                          label={t("created")}
                          name="OrderStatus"
                          type={type}
                          id={`Created`}
                          checked={status === "Created"}
                          onChange={onStatus}
                          value={"Created"}
                        />
                        <Form.Check
                          reverse
                          label={t("receivedWithIssues")}
                          name="OrderStatus"
                          type={type}
                          id={`ReceivedWithIssues`}
                          checked={status === "Received,comments"}
                          onChange={onStatus}
                          value={"Received,comments"}
                        />
                        <Form.Check
                          reverse
                          label={t("received")}
                          name="OrderStatus"
                          type={type}
                          id={`Received`}
                          checked={status === "Received"}
                          onChange={onStatus}
                          value={"Received"}
                        />
                        <Form.Check
                          reverse
                          label={t("approvedWithIssues")}
                          name="OrderStatus"
                          type={type}
                          id={`ApprovedWithIssues`}
                          checked={status === "Approved,comments"}
                          onChange={onStatus}
                          value={"Approved,comments"}
                        />
                        <Form.Check
                          reverse
                          label={t("approved")}
                          name="OrderStatus"
                          type={type}
                          id={`Approved`}
                          checked={status === "Approved"}
                          onChange={onStatus}
                          value={"Approved"}
                        />
                        <Form.Check
                          reverse
                          label={t("rejected")}
                          name="OrderStatus"
                          type={type}
                          id={`Rejected`}
                          checked={status === "Rejected"}
                          onChange={onStatus}
                          value={"Rejected"}
                        />
                      </>
                    )}
                </div>
              ))}
            </div>
            <div className="commonBase mb-3">
              <div
                className="d-flex justify-content-between pointer"
                onClick={() => setExpandTable(!expandTable)}
              >
                <div>
                  <h5>Accounting Information</h5>
                </div>
                <div>
                  {expandTable ? (
                    <i className="fa fa-angle-up"></i>
                  ) : (
                    <i className="fa fa-angle-down"></i>
                  )}
                </div>
              </div>
              {expandTable && (
                <div className="poTable respTable aiTable">
                  <table>
                    <thead>
                      <tr>
                        <th>
                          {departmentId ? (
                            <>
                              <span>Department Unit</span>
                              <br></br> <span>Accounting Key</span>
                            </>
                          ) : (
                            <>
                              <span>Operator Unit</span>
                              <br></br> <span>Accounting Key</span>
                            </>
                          )}
                        </th>

                        {accountingInformation?.length > 0 &&
                          accountingInformation[0]?.accountDimension
                            ?.GLFieldName && (
                            <th>
                              {
                                accountingInformation[0]?.accountDimension
                                  ?.GLFieldName
                              }
                            </th>
                          )}
                        <th>UNSPSC</th>
                        <th>Quantity</th>
                        <th>Amount</th>
                        <th>Currency</th>
                        <th>VAT</th>
                        <th>User Accounting Key</th>
                      </tr>
                    </thead>
                    <tbody>
                      {accountingInformation.length &&
                        accountingInformation.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                {accoutingInfoType === "businessUnit"
                                  ? item?.PastOrder?.BusinessUnit?.accountingKey
                                  : item?.PastOrder?.Department?.accountingKey}
                              </td>
                              <td>
                                {item?.unspsc && item?.accountDimension?.GL
                                  ? item?.accountDimension?.GL?.key
                                  : "----"}
                              </td>
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip
                                    id="tooltip"
                                    style={{ fontSize: "10px" }}
                                  >
                                    {item?.unspscSegment
                                      ? item?.unspscSegment?.SegmentTitle
                                      : item?.unspscFamily
                                      ? item?.unspscFamily?.FamilyTitle
                                      : item?.unspscClass
                                      ? item?.unspscClass?.ClassTitle
                                      : item?.unspscCommodity?.CommodityTitle}
                                  </Tooltip>
                                }
                              >
                                <td>{item?.unspsc ? item?.unspsc : "----"}</td>
                              </OverlayTrigger>

                              <td>
                                {item?.totalQty ? item?.totalQty : "----"}
                              </td>
                              <td>
                                {item?.totalSalePrice
                                  ? item?.totalSalePrice
                                  : "----"}
                              </td>

                              <td>
                                {item?.currencyType
                                  ? item?.currencyType
                                  : "----"}
                              </td>
                              <td>
                                {item?.VATpercent
                                  ? `${item?.VATpercent} %`
                                  : "----"}
                              </td>

                              <td>{"----"}</td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            <button className="commonButton my-3" onClick={onUpdate}>
              Save
            </button>
          </div>
        </div>
      </div>
      <Modal
        size="lg"
        show={logs}
        onHide={handleCloseLogs}
        dialogClassName="custom-modal-size"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h4 className="mb-3">All Logs</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Nav
            fill
            variant="tabs"
            defaultActiveKey={activeTab}
            onSelect={handleSelect}
            className="navTb"
          >
            <Nav.Item>
              <Nav.Link eventKey="link-1">QC Status</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="link-2">Comment Status</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="link-3">Order Logs</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="link-4">Quantity Logs</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="link-5">Operator Unit Logs</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="link-6">GHG Key Logs</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="link-7">Delivery Date & Time Logs</Nav.Link>
            </Nav.Item>
          </Nav>
          {activeTab === "link-1" && (
            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>Date and Time</th>
                    <th>Question</th>
                    <th>Answer</th>
                  </tr>
                </thead>
                <tbody>
                  <>
                    {allLogs?.SelectedPastOrderQualityControls?.sort(
                      (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                    )?.map((s) => (
                      <tr className={isActive ? null : "inactive"}>
                        <td data-label="Date and Time">
                          {moment(s?.createdAt).format("DD-MM-YYYY,HH:mm:ss")}
                        </td>
                        <td data-label="Question">{s?.QualityControl?.text}</td>
                        <td
                          data-label="Answer"
                          style={{
                            color: s?.answer === "Yes" ? "green" : "red",
                          }}
                        >
                          {s?.answer}&nbsp;
                        </td>
                      </tr>
                    ))}
                  </>
                </tbody>
              </table>
            </div>
          )}
          {activeTab === "link-2" && (
            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>Date and Time</th>
                    <th>User</th>
                    <th>Comment</th>
                  </tr>
                </thead>
                <tbody>
                  <>
                    {allLogs?.CommentsLogs?.sort(
                      (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                    )?.map((s) => (
                      <tr className={isActive ? null : "inactive"}>
                        <td data-label="Date and Time">
                          {moment(s?.createdAt).format("DD-MM-YYYY,HH:mm:ss")}
                        </td>
                        <td data-label="User">
                          {s?.User.firstName} {s?.User.lastName}
                        </td>
                        <td data-label="Comment">{s?.comments}</td>
                      </tr>
                    ))}
                  </>
                </tbody>
              </table>
            </div>
          )}
          {activeTab === "link-3" && (
            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>Date and Time</th>
                    <th>User</th>
                    <th>Order Status</th>
                  </tr>
                </thead>
                <tbody>
                  <>
                    {allLogs?.orderStatusLogs
                      ?.sort(
                        (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                      )
                      ?.map((s) => (
                        <tr className={isActive ? null : "inactive"}>
                          <td data-label="Date and Time">
                            {moment(s?.createdAt).format("DD-MM-YYYY,HH:mm:ss")}
                          </td>
                          <td data-label="User">
                            {s?.User.firstName} {s?.User.lastName}
                          </td>
                          <td data-label="orderStatus">{s?.orderStatus}</td>
                        </tr>
                      ))}
                  </>
                </tbody>
              </table>
            </div>
          )}
          {activeTab === "link-4" && (
            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>Date and Time</th>
                    <th>User</th>
                    <th>Product Name</th>
                    <th>Quantity</th>
                    <th>Received Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  <>
                    {allLogs?.QuantityLogs?.sort(
                      (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                    )?.map((s) => (
                      <tr className={isActive ? null : "inactive"}>
                        <td data-label="Date and Time">
                          {moment(s?.createdAt).format("DD-MM-YYYY,HH:mm:ss")}
                        </td>
                        <td data-label="User">
                          {s?.User.firstName} {s?.User.lastName}
                        </td>
                        <td data-label="item">{s?.item}</td>
                        <td data-label="quantity">{s?.quantity}</td>
                        <td data-label="receivedQuantity">
                          {s?.receivedQuantity}
                        </td>
                      </tr>
                    ))}
                  </>
                </tbody>
              </table>
            </div>
          )}
          {activeTab === "link-5" && (
            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>Date and Time</th>
                    <th>User</th>
                    <th>Operator Unit</th>
                  </tr>
                </thead>
                <tbody>
                  <>
                    {allLogs?.businessLogs
                      ?.sort(
                        (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                      )
                      ?.map((s) => (
                        <tr className={isActive ? null : "inactive"}>
                          <td data-label="Date and Time">
                            {moment(s?.updatedAt).format("DD-MM-YYYY,HH:mm:ss")}
                          </td>
                          <td data-label="User">
                            {s?.User?.firstName} {s?.User?.lastName}
                          </td>
                          <td data-label="item">{s?.BusinessUnit?.name}</td>
                        </tr>
                      ))}
                  </>
                </tbody>
              </table>
            </div>
          )}
          {activeTab === "link-6" && (
            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>Date and Time</th>
                    <th>User</th>
                    <th>GHG Key</th>
                    <th>GHG Name</th>
                  </tr>
                </thead>
                <tbody>
                  <>
                    {allLogs?.ghgLogs
                      ?.sort(
                        (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                      )
                      ?.map((s) => (
                        <tr className={isActive ? null : "inactive"}>
                          <td data-label="Date and Time">
                            {moment(s?.updatedAt).format("DD-MM-YYYY,HH:mm:ss")}
                          </td>
                          <td data-label="User">
                            {s?.User?.firstName} {s?.User?.lastName}
                          </td>
                          <td data-label="item">{s?.MasterGHG?.key}</td>
                          <td data-label="item">{s?.MasterGHG?.value}</td>
                        </tr>
                      ))}
                  </>
                </tbody>
              </table>
            </div>
          )}
          {activeTab === "link-7" && (
            <div className="dbMaintable respTable">
              <table>
                <thead>
                  <tr>
                    <th>Date and Time</th>
                    <th>User</th>
                    <th>Deliveri Date & Time</th>
                  </tr>
                </thead>
                <tbody>
                  <>
                    {allLogs?.deliveryLogs
                      ?.sort(
                        (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                      )
                      ?.map((s) => (
                        <tr className={isActive ? null : "inactive"}>
                          <td data-label="Date and Time">
                            {moment(s?.updatedAt).format("DD-MM-YYYY,HH:mm:ss")}
                          </td>
                          <td data-label="User">
                            {s?.User?.firstName} {s?.User?.lastName}
                          </td>
                          <td data-label="item">
                            {moment(s?.deliveryDateTime).format(
                              "DD-MM-YYYY,HH:mm:ss"
                            )}
                          </td>
                        </tr>
                      ))}
                  </>
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
      </Modal>

{/* Purchase History Modal */}
{/* <Modal
        size="lg"
        show={purchaseHistoriesModal}
        onHide={() => setPurchaseHistoryModal(false)}
        dialogClassName="custom-modal-size"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h4 className="mb-3">{t("purchaseHistory")}</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="dbMaintable respTable">
            <table>
              <thead>
                <tr>
                  <th>{t("invoice_id")}</th>
                  <th>{t("Order Date")}</th>
                  <th>{t("User")}</th>
                  <th>{t("productNumber")}</th>
                  <th>{t("productName")}</th>
                  <th>{t("Purchase Quantity")}</th>
                  <th>{t("Price")}</th>
                  <th>{t("co2_qty")}</th>
                  <th>{t("kgco2")}</th>
                  <th>{t("Change Percentage")}</th>
                </tr>
              </thead>

              <tbody>
                {purchaseHistory?.length > 0 &&
                  purchaseHistory
                    ?.sort(
                      (a, b) => new Date(b?.createdAt) - new Date(a?.createdAt)
                    )
                    ?.map((item) => {
                      return (
                        <tr key={item.id}>
                          <td data-label="Order ID">
                              <i className="fa-solid fa-up-right-from-square me-1"></i>
                              {item.orderId}
                          </td>
                          <td data-label="Order Date">
                            <Link to="javascript:void(0)">
                              {moment(item.createdAt).format("DD-MM-YYYY")}
                            </Link>
                          </td>
                          <td data-label="User Name">
                            <Link to="javascript:void(0)">
                              {`${item?.User?.firstName} ${item?.User?.lastName}`}
                            </Link>
                          </td>
                          <td data-label="Product number">
                            <Link to="javascript:void(0)">
                              {item?.Product?.number}
                            </Link>
                          </td>
                          <td data-label="Product Name">
                            <Link to="javascript:void(0)">
                              {item?.Product?.name}
                            </Link>
                          </td>
                          <td data-label="Total Quantity per Base units">
                            <Link to="javascript:void(0)">
                              {item.totalQuantityPerBaseUnits}
                            </Link>
                          </td>
                          <td data-label="Base unit Price">
                            <Link to="javascript:void(0)">
                              {item.currencyType}{" "}
                              {item.baseUnitPrice.toFixed(2)}
                            </Link>
                          </td>
                          <td data-label="CO2e">{item?.co2_qty}</td>
                          <td data-label="KgCO2e">{item?.kgco2_co2_unit}</td>
                          <td data-label="Change Percentage">
                            <Link to="javascript:void(0)">
                              {item?.changePercentage
                                ? `${Number(item?.changePercentage).toFixed(
                                    2
                                  )} %`
                                : "----"}
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal> */}

            {/* Model to show Purchase History Start*/}
              <Modal
                size="lg"
                show={showPurchaseModal}
                onHide={() => setShowPurchaseModal(false)}
                dialogClassName="custom-modal-size"
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    <h4 className="mb-3">{t("purchaseHistory")}</h4>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="dbMaintable respTable">
                    <table>
                      <thead>
                        <tr>
                          <th>{t("orderId")}</th>
                          <th>{t("Order Date")}</th>
                          <th>{t("User")}</th>
                          <th>{t("productNumber")}</th>
                          <th>{t("productName")}</th>
                          <th>{t("Purchase Quantity")}</th>
                          <th>{t("co2_qty")}</th>
                          <th>{t("kgco2")}</th>
                          <th>{t("Price")}</th>
                          <th>{t("Change Percentage")}</th>
                        </tr>
                      </thead>
      
                      <tbody>
                        {selectedProductDetails?.PurchaseHistories?.length > 0 &&
                          selectedProductDetails?.PurchaseHistories
                            ?.sort(
                              (a, b) =>
                                new Date(b?.createdAt) - new Date(a?.createdAt)
                            )
                            ?.map((item) => {
                              return (
                                <tr key={item.id} className="">
                                  <td data-label="Order ID">
                                    {/* <Link
                                      to={`/pastorderedit?id=${selectedPastOrderDetails.id}&invoiceId=${selectedInvoiceId}`}
                                      target="_blank"
                                      className="text-primary"
                                      title="View Order Details"
                                    >
                                      <i className="fa-solid fa-up-right-from-square me-1"></i> */}
                                      {selectedProductDetails?.pastOrder?.id}
                                    {/* </Link> */}
                                  </td>
                                  <td data-label="Order Date">
                                    {moment(item.createdAt).format("DD-MM-YYYY")}
                                  </td>
                                  <td data-label="User Name">
                                    {`${item?.User?.firstName} ${item?.User?.lastName}`}
                                  </td>
                                  <td data-label="Product Number">
                                  <Link
                                      to={`/productdetails?id=${selectedProductDetails.id}`}
                                      target="_blank"
                                      className="text-primary"
                                      title="View Order Details"
                                    >
                                    {`${selectedProductDetails?.number}`}
                                    </Link>
                                  </td>
                                  <td data-label="Product Name">
                                    {`${selectedProductDetails.name}`}
                                  </td>
                                  <td data-label="Total Quantity per Base units">
                                    {item.totalQuantityPerBaseUnits}
                                  </td>
                                  <td data-label="CO2e">
                                   {selectedProductDetails?.co2_qty}
                                  </td>
                                  <td data-label="KgCO2e">
                                  {selectedProductDetails?.kgco2_co2_unit}
                                  </td>
                                  <td data-label="Base unit Price">
                                    {item.currencyType}{" "}
                                    {currencyFormatter
                                      .format(item.saleUnit, {
                                        code: "ISK",
                                      })
                                      .replace("kr.", "")
                                      .trim()}
                                  </td>
                                  <td data-label="Change In Percentage">
                                    {item?.changePercentage
                                      ? `${Number(item?.changePercentage).toFixed(
                                          2
                                        )} %`
                                      : ""}
                                  </td>
                                </tr>
                              );
                            })}
                      </tbody>
                    </table>
                  </div>
                </Modal.Body>
              </Modal>
            {/* Model to show Purchase History End */}


      <Modal size="lg" show={showUnspc} onHide={handleCloseUnspc} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="mb-0">{t("add")} UNSPSC</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="dbMaintable productMainScroll">
            {search && <>Total results: {searchResults.length}</>}

            <div className="searchParentDiv">
              <div>
                <input
                  className="productSearch py-2 px-4"
                  type="search"
                  placeholder="Type something to search..."
                  onChange={(e) => searchUnspsc(e.target.value)}
                />
              </div>
              {search && (
                <div className="searchResults">
                  {searchResults && searchResults.length > 0 ? (
                    <>
                      {searchResults.map((result, index) => (
                        <div
                          className="form-check d-flex justify-content-between"
                          key={index}
                          onClick={() => getUnspscData(result)}
                        >
                          <div>
                            {index +
                              1 +
                              ". " +
                              result.value +
                              " (" +
                              result.belongsTo +
                              " " +
                              result.key +
                              ")"}
                          </div>
                          <div>
                            <i
                              className="fa fa-plus theme-color"
                              aria-hidden="true"
                              title="Click to Add"
                            ></i>
                          </div>
                        </div>
                      ))}

                      {totalSearchResult > searchResults.length && (
                        <div className="load-more d-flex justify-content-center">
                          {isSearchLoading ? (
                            <button disabled>
                              <i className="fa-solid fa-spinner fa-spin"></i>{" "}
                            </button>
                          ) : (
                            !searchResultsEnd && (
                              <button onClick={loadMoreResults}>
                                Load More
                              </button>
                            )
                          )}
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="form-check" style={{ textAlign: "center" }}>
                      {isSearchLoading ? (
                        <i className="fa-solid fa-spinner fa-spin"></i>
                      ) : (
                        "No Result Found"
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>

            <h2 className="d-flex justify-content-center">{t("OR")}</h2>
            <h5 className="mt-4 mb-3">UNSPSC :</h5>
            <div className="accordion unspscAccord" id="unAccordion">
              <div className="accordion-item">
                {segmentDataList
                  .sort((a, b) => a?.Segment - b?.Segment)
                  ?.map((segment) => (
                    <TreeItem
                      key={segment.Segment}
                      title={t("segment_code", {
                        segment: segment.Segment,
                        title: segment.SegmentTitle,
                      })}
                      isOpen={openSegment === segment.Segment}
                      toggleOpen={() => handleSegmentClick(segment.Segment)}
                      onClick={onDataSegment.bind(
                        segment?.Segment,
                        `${segment?.Segment}`
                      )}
                    >
                      {allUnspcFamily?.map((family) => (
                        <TreeItem
                          key={family.Family}
                          title={t("family_code", {
                            family: family.Family,
                            title: family.FamilyTitle,
                          })}
                          isOpen={openFamily === family.Family}
                          toggleOpen={() =>
                            handleFamilyClick(segment.Segment, family.Family)
                          }
                          onClick={onDataFamily.bind(
                            family?.Family,
                            `${family?.Family}`
                          )}
                        >
                          {allUnspcClass?.map((classItem) => (
                            <TreeItem
                              key={classItem.Class}
                              title={t("class_code", {
                                class: classItem.Class,
                                title: classItem.ClassTitle,
                              })}
                              isOpen={openClass === classItem.Class}
                              toggleOpen={() =>
                                handleClassClick(family.Family, classItem.Class)
                              }
                              onClick={onDataClass.bind(
                                classItem?.Class,
                                `${classItem?.Class}`
                              )}
                            >
                              {allUnspcComodity?.map((commodity) => (
                                <TreeItem
                                  key={commodity.Commodity}
                                  title={t("commodity_code", {
                                    commodity: commodity.Commodity,
                                    title: commodity.CommodityTitle,
                                  })}
                                />
                              ))}
                            </TreeItem>
                          ))}
                        </TreeItem>
                      ))}
                    </TreeItem>
                  ))}
              </div>
            </div>
          </div>

          <div className="d-flex">
            <button className="commonButton ms-auto p-2" onClick={searchPage}>
              {t("View More")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Pastorderedit;
